import _, { isNull } from 'lodash';

/**
 *
 * @param {object} row
 * @param {string|number} value
 * @returns {Error|boolean}
 */
export const filterType = (row, value) => {
  if (row && row.hasOwnProperty('type') && !_.isNull(value)) {
    const rowTypeToNumber = Number(row.type);
    const valueToNumber = Number(value);

    if (_.isNaN(rowTypeToNumber) || _.isNaN(valueToNumber)) {
      return new Error('Error format row type of filter value')
    }
    return rowTypeToNumber === valueToNumber;
  }
  return true;
};

/**
 *
 * @param {object} row
 * @param {string|number} value
 * @returns {Error|boolean}
 */
export const filterStatus = (row, value) => {
  if (row && row.hasOwnProperty('status') && !_.isNull(value)) {
    const rowStatusToNumber = Number(row.status);
    const valueToNumber = Number(value);

    if (_.isNaN(rowStatusToNumber) || _.isNaN(valueToNumber)) {
      return new Error('Error format row type of filter value')
    }
    return rowStatusToNumber === valueToNumber;
  }
  return true;
};

/**
 *
 * @param {object} row
 * @param {array} value
 * @returns {Error|boolean}
 */
export const filterProvider = (row, value) => {
  if (row && row.hasOwnProperty('provider_id') && !_.isNull(value)) {
    if (_.isArray(value)) {
      const mode = Number(row.mode);
      const find = value.find((item) => {
        if (mode) {
          const providerId = Number(row.provider_id);
          return item.value === providerId;
        }
        return item.value === 'manual';
      })
      return !!find;
    }
  }
  return true;
};

/**
 *
 * @param {object} row
 * @param {string|number} value
 * @returns {Error|boolean}
 */
export const filterSubcategory = (row, value) => {
  if (row && row.hasOwnProperty('subcategory') && !_.isNull(value)) {
    const { subcategory } = row;
    if (value === 'Other' && isNull(subcategory)) {
      return true;
    }
    return subcategory === value;
  }
  return true;
};
